import React, { useState } from "react";

import EditPublication from "./EditPublication";

const blankMediaJob = { mediaOutletId: -1, mediaOutletName: "", title: "", from: "", to: "" };

// The "add a publication" affordance — a button that expands into a blank row editor. Mirrors
// pr_profiles' NewEmploymentLine.
function NewPublicationLine({ onNewMediaJob, disabled = false }) {
  const [adding, setAdding] = useState(false);

  const toggleAdding = () => {
    setAdding((prev) => !prev);
  };

  const confirmAdding = (mediaJob) => {
    setAdding(false);
    onNewMediaJob(mediaJob);
  };

  return adding ? (
    <EditPublication mediaJob={blankMediaJob} onConfirm={confirmAdding} onCancel={toggleAdding} disabled={disabled} />
  ) : (
    <tr>
      <td colSpan="999">
        <button onClick={toggleAdding} type="button" className="btn btn-sm btn-outline-primary" disabled={disabled}>
          New Job
        </button>
      </td>
    </tr>
  );
}

export default NewPublicationLine;
